import { Flex } from "@chakra-ui/react";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";

const maxww = "50rem";

const Layout = ({ children, type, ...rest }) => {
  const ismobile = useCheckMobileScreen();

  const w = ismobile ? "15rem" : maxww;
  const wrapProps = {};
  if (type === "w-fixed") {
    wrapProps.minW = w;
  }

  if (type === "f-noscroll") {
    return (
      <Flex
        // align={"center"}
        pt={"1px"}
        direction={"column"}
        flex={1}
        maxW={maxww}
        gap={"1rem"}
        overflow={"hidden"}
        alignSelf={"center"}
        w="100%"
      >
        {children}
      </Flex>
    );
  }

  if (type === "w-75") {
    return (
      <Flex
        direction={"column"}
        overflow={"scroll"}
        flex={1}
        {...wrapProps}
        // w={"75%"}
        px={"12.5%"}
        alignSelf={"center"}
      >
        {children}
      </Flex>
    );
  }

  return (
    <Flex
      pt={"1px"}
      direction={"column"}
      overflow={"scroll"}
      flex={1}
      align={"center"}
    >
      <Flex direction={"column"} flex={1} maxW={w}  pb={"2px"} {...wrapProps} {...rest}>
        {children}
      </Flex>
    </Flex>
  );
};

export default Layout;
